












































































































































import Vue from 'vue';
import countryLs from '../pays.json';
const countryList = countryLs as string[];

import { core } from '../tradeCore';
import { demo } from '../tradeDemo';

async function control() {
    return new Promise((resolve, reject) => {
        const token = window.localStorage.getItem('token');
        const id = window.localStorage.getItem('id');
        const data = { token: token, userid: id };

        core.controler
            .getsolde({ body: { data: JSON.stringify(data) } })

            .then((res) => {
                if (res.status == 200) {
                    resolve(Number(res.data.solde));
                } else {
                    reject('error');
                }
            })
            .catch((err) => {
                reject('error');
            });
    });
}
async function getDemoSolde() {
    return new Promise((resolve, reject) => {
        const token = window.localStorage.getItem('token');
        const id = window.localStorage.getItem('id');
        const data = { token: token, userid: id };

        demo.controler
            .getsolde({ body: { data: JSON.stringify(data) } })

            .then((res) => {
                if (res.status == 200) {
                    resolve(Number(res.data.solde));
                } else {
                    reject('error');
                }
            })
            .catch((err) => {
                reject('error');
            });
    });
}
async function updateDemoSolde() {
    return new Promise((resolve, reject) => {
        const token = window.localStorage.getItem('token');
        const id = window.localStorage.getItem('id');
        const data = { token: token, userid: id, solde: 1000 };
        demo.controler
            .soldeupdate({ body: { data: JSON.stringify(data) } })

            .then((res) => {
                if (res.status == 200) {
                    resolve('done');
                } else {
                    reject('error');
                }
            })
            .catch((err) => {
                reject('error');
            });
    });
}

export default Vue.extend({
    name: 'Register',
    watch: {
        datepicker(val) {
            val && setTimeout(() => (this.activePicker = 'YEAR'));
        },
        date(val) {
            this.user['age'] = Number(this.getAge());
        },
    },
    beforeMount() {
        control().then(
            (res: any) => {
                this.$emit('solde', Number(res));
                this.solde = Number(res);
                getDemoSolde().then((val: any) => {
                    this.demo = Number(val);
                    this.$emit('demo', val);
                });
            },
            (err) => {
                this.notifyError = true;
                this.notificationTitle = `Session expiré`;
                this.notificationText = `Veuillez vous reconnecter`;
            }
        );
    },
    data: () => ({
        solde: 0,
        validate: false,
        loading: false,
        loading2: false,
        loadingResetDemo: false,
        notify: false,
        notifyError: false,
        notificationText: ``,
        notificationTitle: '',
        colors: {
            candleUpLight: {
                text: 'Candle Up Light theme',
                value: window.localStorage.getItem('cul') || '#03A9F4',
            },
            candleDownLight: {
                text: 'Candle Down Light theme',
                value: window.localStorage.getItem('cdl') || '#FF3333',
            },
            candleUpDark: {
                text: 'Candle Up Dark theme',
                value: window.localStorage.getItem('cud') || '#1E88E5',
            },
            candleDownDark: {
                text: 'Candle Down Dark theme',
                value: window.localStorage.getItem('cdd') || '#C62828',
            },
        },

        user: {
            name: '',
            first_name: '',
            age: '' as Number | String,
            country: '',
            email: '',
            phone: '' as Number | String,
        },
        demo: 0,
        showPassword: false,
        showPassword2: false,
        password: '',
        confirmPass: '',
        date: '',
        datepicker: false,
        activePicker: '',
        menu: false,
        countryList: countryList,

        //////////////////////////////
        search: '',
        headers: [
            {
                text: 'Transaction',
                align: 'start',
                sortable: true,
                value: 'symbol',
            },
            { text: 'Type', value: 'type' },
            { text: 'Valeur', value: 'gain' },
            { text: 'Date', value: 'date' },
        ],
        histories: [] as any[],
        historiesLoading: false,
        ////////////////////////////////
        emailRules: [
            (value: any) => !!value || 'Requise.',
            (value: any) => {
                const pattern =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'e-mail invalide.';
            },
        ],
        passwordRules: [
            (value: any) => !!value || 'Requise.',
            (value: any) => value.length >= 6 || 'Min 6 caractères.',
            (value: any) => value.length <= 30 || 'Max 30 caractères',
        ],
        namesRules: [
            (value: any) => !!value || 'Requise.',
            (value: any) => value.length >= 2 || 'Min 2 caractères.',
            (value: any) => value.length <= 30 || 'Max 30 caractères',
        ],
        numberRules: [
            (value: any) => !!value || 'Requise.',
            (value: any) => (value.length >= 10 && !isNaN(value)) || 'Numéro invalide.',
            (value: any) =>
                (String(value).indexOf('+') == -1 &&
                    String(value).indexOf('-') == -1 &&
                    String(value).indexOf('.') == -1) ||
                'Numéro invalide.',
            (value: any) => (value.length <= 15 && !isNaN(value)) || 'Numéro invalide.',
        ],
        requiredRules: [(value: any) => !!value || 'Requise.'],
    }),

    methods: {
        resetDemo() {
            this.loadingResetDemo = true;
            updateDemoSolde().then((res: any) => {
                getDemoSolde().then((val: any) => {
                    this.demo = Number(val);
                    this.$emit('demo', val);
                    this.loadingResetDemo = false;
                });
            });
        },
        saveSettings() {
            this.loading2 = true;

            window.localStorage.setItem('cul', this.colors.candleUpLight.value);
            window.localStorage.setItem('cdl', this.colors.candleDownLight.value);
            window.localStorage.setItem('cud', this.colors.candleUpDark.value);
            window.localStorage.setItem('cdd', this.colors.candleDownDark.value);
            this.notificationTitle = 'Settings saved';
            this.notificationText = 'Press ok to continue';
            this.notify = true;
            this.loading2 = false;
        },

        getAge() {
            let age = Number(Date.now()) - Number(new Date(this.date));
            return isNaN(Math.floor(age / 31536000000)) ? '' : Math.floor(age / 31536000000);
        },
        progress() {
            return Math.min(100, this.password.length * 10);
        },
        color() {
            let result = 'error';
            if (this.progress() / 10 < 6) {
                result = 'error';
            } else if (this.progress() / 10 < 8) {
                result = 'warning';
            } else if (this.progress() / 10 < 10) {
                result = 'yellow';
            } else {
                result = 'green';
            }
            return result;
        },
        toFixed(val: number, fract: number) {
            if (isNaN(val)) {
                return '-';
            } else {
                return Number(Number(val).toFixed(fract));
            }
        },
    },
    components: {},
});
